import { render } from "./ShowImages.vue?vue&type=template&id=4070c642&scoped=true"
import script from "./ShowImages.vue?vue&type=script&lang=js"
export * from "./ShowImages.vue?vue&type=script&lang=js"

import "./ShowImages.vue?vue&type=style&index=0&id=4070c642&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4070c642"]])

export default __exports__